export const PRIMARY_TEXT_GREY = "#878787";
